module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chk"
  }, [_vm._l((_vm.grupos), function(grupo) {
    return [(grupo.titulo === 'Enquadramento e Parecer Jurídico') ? _vm._t("antes-enquadramento") : _vm._e(), _vm._v(" "), _c('section', {
      key: grupo.titulo,
      staticClass: "chk-secao"
    }, [_c('div', {
      staticClass: "chk-titulo"
    }, [_vm._v(_vm._s(grupo.titulo))]), _vm._v(" "), (grupo.titulo === 'Regularidade da Proposta e da Proponente') ? _vm._t("inicio-regularidade") : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "chk-card"
    }, [_vm._l((grupo.itens), function(item) {
      return [(item.texto) ? _c('div', {
        key: item.chave,
        staticClass: "chk-row chk-row--texto",
        class: {
          'chk-row--ok': _vm.respondido(item.chave)
        }
      }, [_c('label', {
        staticClass: "chk-q"
      }, [_vm._v(_vm._s(item.pergunta))]), _vm._v(" "), _c('input', {
        staticClass: "chk-input",
        attrs: {
          "type": "text",
          "maxlength": "255",
          "disabled": _vm.disabled
        },
        domProps: {
          "value": _vm.dados[item.chave]
        },
        on: {
          "input": function($event) {
            return _vm.atualiza(item.chave, $event.target.value)
          }
        }
      })]) : _c('div', {
        key: item.chave,
        staticClass: "chk-row",
        class: {
          'chk-row--ok': _vm.respondido(item.chave)
        }
      }, [_c('span', {
        staticClass: "chk-q"
      }, [_vm._v(_vm._s(item.pergunta))]), _vm._v(" "), _c('div', {
        staticClass: "chk-seg",
        attrs: {
          "role": "group"
        }
      }, _vm._l((_vm.opcoes), function(opcao) {
        return _c('button', {
          key: opcao,
          staticClass: "chk-seg-btn",
          class: _vm.classeOpcao(item.chave, opcao),
          attrs: {
            "type": "button",
            "disabled": _vm.disabled
          },
          on: {
            "click": function($event) {
              return _vm.alterna(item.chave, opcao)
            }
          }
        }, [_vm._v(_vm._s(opcao))])
      }), 0)])]
    }), _vm._v(" "), (grupo.observacaoChave) ? _c('div', {
      staticClass: "chk-row chk-row--texto",
      class: {
        'chk-row--ok': _vm.respondido(grupo.observacaoChave)
      }
    }, [_c('label', {
      staticClass: "chk-q"
    }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea', {
      staticClass: "chk-input",
      attrs: {
        "rows": "3",
        "disabled": _vm.disabled
      },
      domProps: {
        "value": _vm.dados[grupo.observacaoChave]
      },
      on: {
        "input": function($event) {
          return _vm.atualiza(grupo.observacaoChave, $event.target.value)
        }
      }
    })]) : _vm._e()], 2)], 2)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ead57f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/checklistAnalise.vue
// module id = 1901
// module chunks = 1